import {
  GetStudyDocumentsLimitsResponse,
  GetStudyNotebooksByIdDocumentsResponse,
  GetStudyNotebooksResponse,
  PostStudyNotebooksByIdDocumentsData,
  PostStudyNotebooksByIdDocumentsResponse,
} from "../client";

export type StudyNotUploadedDocument = Omit<
  PostStudyNotebooksByIdDocumentsData["body"],
  "metadata"
> & {
  metadata: Record<string, any>;
};
export type StudyUploadedDocument = GetStudyNotebooksByIdDocumentsResponse[0];
export type StudyDocument = StudyUploadedDocument;
export type StudyUserLimits = GetStudyDocumentsLimitsResponse;

export type NotebookExtended = GetStudyNotebooksResponse["notebooks"][0];

export type UploadableURL = {
  url: string;
};
// course file, external file, URL
export type UploadableSource = StudyNotUploadedDocument | File | UploadableURL;
export const isCourseSource = (source: UploadableSource) =>
  !isURLSource(source) && !isExternalSource(source);

export const isExternalSource = (source: UploadableSource) =>
  source instanceof File;

export const isURLSource = (source: UploadableSource) => "url" in source;

// tasks

export interface FinalAssignment {
  // color: string; // color assigned to course
  html_url: string; // link to assignment page
  name: string; // title of assignment
  points_possible: number;
  due_at: string;
  course_id: string; // course the assignment belongs to
  id: string; // id of the assignment
  plannable_id: string; // id of planner item for marking complete
  override_id?: string; // id of existing planner override
  submitted: boolean; // has the user submitted it?
  graded: boolean; // has the teacher graded it?
  graded_at: string; // date the teacher graded (if graded)
  score: number; // grade assigned, 0 if ungraded or unsubmitted
  grade?: string; // grade displayed (letter scale or point scale)
  type: AssignmentType;
  // course_name: string; // via useCourseName
  marked_complete: boolean; // marked complete in the sidebar or through the planner
  late?: boolean; // true if all assignment submissions are late
  // position: number;
  needs_grading_count?: number;
  total_submissions?: number;
}

// possible values from plannable_type field
export enum AssignmentType {
  ASSIGNMENT = "assignment",
  QUIZ = "quiz",
  DISCUSSION = "discussion_topic",
  NOTE = "planner_note",
  ANNOUNCEMENT = "announcement",
  EVENT = "calender_event",
  GRADESCOPE = "gradescope",
}
